const styles = ({ COLORS }) => ({
  container: {
    display: 'flex',
    margin: '30px 0 20px',
    '& p a': {
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  },
  content: {
    '& button': {
      marginLeft: '10px'
    }
  },
  title: {
    margin: 0
  }
})

export default styles
